import React, { useState, useMemo, useCallback, useEffect } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import appConfig from 'app-config';
import { useAuthentication } from "@xengage/gw-digital-auth-react";
import { MLGAFInfoService as GatewayMLGAFInfoService } from "gw-capability-gateway";
import { MLGafUtil } from 'ml-portals-util-react';
import { ViewModelForm } from "@xengage/gw-portals-viewmodel-react";
import { useTranslator } from "@jutro/locale";
import { RadioButtonField } from "@jutro/legacy/components.js";
import { platformMessages } from "ml-components-platform-react";
import { MLModalService } from "ml-portals-services-react";
import metadata from "./MLEmployeeEligibility.metadata.json5";
import messages from "./MLEmployeeEligibility.messages.js";
import styles from "./MLEmployeeEligibility.module.scss";

function MLEmployeeEligibility(props) {
  const {
    model,
    eligibilityInfos,
    isEndorsement,
    quoteID,
    setDisableNextButton,
    pni,
    sni,
    onEligCheckbox,
    isBasedOnPayroll,
    isCurrentPayPlanPayroll
  } = props;
  const [ssnOrAltId, setSsnOrAltId] = useState(undefined);
  const [lastName, setLastName] = useState(undefined);
  const [zipCode, setZipCode] = useState(undefined);
  const [selected, setSelected] = useState(undefined);
  const [isChecked, setIsChecked] = useState(false);

  const altIdLabel = _.get(
    model,
    "baseData.gafInfo_ML.alternateIdUsage.value",
    false
  );
  const employeeInfoPath = "baseData.employeeInfo_ML.value";
  const employeeInfo = model?.baseData?.employeeInfo_ML?.value;
  const contactID = employeeInfo?.contactID ?? pni?.publicID;
  const [eligibilityDetails, setEligibilityDetails] =useState(eligibilityInfos);
  const [showErrors, setShowErrors] = useState(true);
  const [isAltSearchUsed, setIsAltSearchUsed] = useState(false);
  const [isVerficationBoxVisible, setIsVerificationBoxVisible] = useState(false);
  const gafPathMl =_.get(model, 'baseData.gafInfo_ML');

  const { showProgressDialog } = MLModalService();
  const gafPathValue = 'baseData.gafInfo_ML.value';
  const alertnateIdLabel = _.get(model, `${gafPathValue}.altIdLabel`, undefined)

  const [insured, setInsured] = useState(isEndorsement ? contactID  : pni?.publicID);
  const { authHeader } = useAuthentication();

  const translator = useTranslator();

  const { validateEmployeeNumberVisibility,
              validateDepartmentNumberVisibility,
              isEditableVisibleForPolicyChange
       } = MLGafUtil();

  useEffect(() => {
    setEligibilityDetails(eligibilityInfos);
  }, [eligibilityInfos]);

  const isQnb = appConfig.portalCode === 'QB';
  const getContactDetails = (val) => [pni, sni].find((contact) => contact?.publicID === val) ?? pni


  const handleCheckbox = (value) => {
    setIsChecked(value);

    if(onEligCheckbox){
      onEligCheckbox(value);
    }
  };

  const handleEligibilitySearch = async () => {
    if ((lastName && zipCode) || ssnOrAltId) {
      let eligibilityPromise;

      if (lastName && zipCode) {
        eligibilityPromise =
          GatewayMLGAFInfoService.gpaCheckEligibilitySSNNameZip(
            lastName,
            zipCode,
            "",
            quoteID,
            authHeader
          );
      } else if (ssnOrAltId) {
        eligibilityPromise =
          GatewayMLGAFInfoService.gpaCheckEligibilitySSNNameZip(
            "",
            "",
            ssnOrAltId,
            quoteID,
            authHeader
          );
      }

      showProgressDialog(platformMessages.loading, eligibilityPromise);

      eligibilityPromise?.then((res) => {
        if (!_.isEmpty(res?.employeeInfos)) {
          setEligibilityDetails(res.employeeInfos);
        } else{
          setEligibilityDetails([]);
        }
      });

      setIsAltSearchUsed(true);
    }
  };

  const handleOptionSelection = async (option, employee) => {
    setSelected(option);

    const updateEmployeeInfo = {...employee, contactID: insured}

    const employeeInfoPromise = GatewayMLGAFInfoService.gpaSelectEmployee(
      updateEmployeeInfo,
      quoteID,
      authHeader
    );

    showProgressDialog(platformMessages.loading, employeeInfoPromise);

    employeeInfoPromise?.then((res) => {
      if (!_.isEmpty(res)) {
        _.set(model, employeeInfoPath, res);

      if(!_.isEmpty(res?.gafInfo)) {
          _.set(model, "baseData.gafInfo_ML.value", res?.gafInfo);
          _.set(model, "baseData.gafInfo_ML.isEditMode.value", true);

      }

        _.set(model, "baseData.gafInfo_ML.eligibilityVerified", res.eligibilityVerified);

        if (!_.isEmpty(res.employeeNumber) && validateEmployeeNumberVisibility(gafPathMl, _.get(model,employeeInfoPath))) {
          _.set(model, 'baseData.gafInfo_ML.employeeNumber.value', res.employeeNumber);
          _.set(model, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', true);
        }
        else {
          _.set(model, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', false);
        }

        if (!_.isEmpty(res.departmentNumber)&& validateDepartmentNumberVisibility(gafPathMl, _.get(model,employeeInfoPath))) {
          _.set(model, 'baseData.gafInfo_ML.departmentNumber.value', res.departmentNumber);
          _.set(model, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', true);
        }
        else {
          _.set(model, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', false);
        }

        if(!_.isUndefined(_.get(model, `${gafPathValue}.employeeDepartmentNumberLength`))){
          _.set(model, 'baseData.gafInfo_ML.departmentNumber.value', res.departmentNumber);
          _.set(model, 'baseData.gafInfo_ML.employeeNumber.value', res.employeeNumber);

          var combinedNumber = res?.employeeNumber.concat(res?.departmentNumber)
          _.set(model, "baseData.gafInfo_ML.employeeDepartmentNumber", combinedNumber);
          _.set(model, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', true);
          _.set(model, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', true);
        }

        if(altIdLabel) {
          _.set(model, "baseData.gafInfo_ML.alternateId", res?.ssn);
        } else {
          _.set(model, "baseData.gafInfo_ML.ssn", res?.ssn);
        }

        setSsnOrAltId("");
        setLastName("");
        setZipCode("");
        const isCheckBoxVisible = handleIsVerificationBoxVisible();
        setIsVerificationBoxVisible(isCheckBoxVisible);

        if(isCheckBoxVisible){
          onEligCheckbox(false);
        } else {
          onEligCheckbox(true);
        }
        setEligibilityDetails([]);
        employeeInfo.gafInfo = null; 
      }
    });
  };

  const handleResetEligibilityDetails = async () => {
    if (!_.isEmpty(employeeInfo?.name)) {
      employeeInfo.gafInfo = null; 
      const resetEmployeeInfoPromise = GatewayMLGAFInfoService.gpaResetEmployee(
        employeeInfo,
        quoteID,
        authHeader
      );

      showProgressDialog(platformMessages.loading, resetEmployeeInfoPromise);

      resetEmployeeInfoPromise?.then(() => {
        _.set(model, employeeInfoPath, {});
        _.set(model,`${employeeInfo}.name`, null);
        _.set(model, "baseData.gafInfo_ML.eligibilityVerified", false);
        _.set(model, "baseData.gafInfo_ML.alternateId", null);
        _.set(model, "baseData.gafInfo_ML.ssn", null);
        _.set(model, 'baseData.gafInfo_ML.isEmployeeNumberAvailable.value', false);
        _.set(model, 'baseData.gafInfo_ML.isDepartmentNumberAvailable.value', false);
        _.set(model, 'baseData.gafInfo_ML.departmentNumber.value', null);
        _.set(model, 'baseData.gafInfo_ML.employeeNumber.value', null);
        _.set(model, "baseData.gafInfo_ML.employeeDepartmentNumber", null);

        setSelected(null);
        setIsChecked(false);
        setShowErrors(true);
        onEligCheckbox(true);
      });
    }
 
    setEligibilityDetails([]);
    setSsnOrAltId("");
    setLastName("");
    setZipCode("");
    setIsAltSearchUsed(false);
  };

  const selectInsuredAvaialbleValues = [
        {
          id: pni?.publicID,
          name: pni?.displayName
        },
        {
          id: sni?.publicID,
          name: sni?.displayName
        }
      ]

  const getCell = (item) => (
    <div className={styles.radioContainer}>
      <RadioButtonField
        availableValues={[
          {
            id: `${item.employeeNumber}`,
            name: item.firstName,
          },
        ]}
        id="employeeSelection"
        onValueChange={(value) => handleOptionSelection(value, item)}
        required
        value={selected}
        isHorizontal
        className={styles.radioButton}
        disabled={isEndorsement && _.get(model, `${employeeInfoPath}.isBasedOnPayroll`, false )}

      />
      <span>{item.name}</span>
    </div>
  );

  const handleCheckEligibility = useCallback((val) => {
    const checkEligibiltyPromise =
      GatewayMLGAFInfoService.gpaCheckEligibilitySSNNameZip(
        getContactDetails(val)?.lastName,
        getContactDetails(val)?.primaryAddress?.postalCode?.substring(0,5),
        "",
        quoteID,
        authHeader
      );

    showProgressDialog(platformMessages.loading, checkEligibiltyPromise);

    checkEligibiltyPromise?.then((res) => {
      if (!_.isEmpty(res?.employeeInfos)) {
        setEligibilityDetails(res.employeeInfos);
      }
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[insured]);


  
  const handleIsVerificationBoxVisible = () => {
    if(_.isEmpty(eligibilityDetails)){
      return false;
    } else {
      const eligResultsCount = eligibilityDetails?.length; 
      return isAltSearchUsed ? eligResultsCount >= 1 : eligResultsCount > 1
    }
  };
  const selectInsuredValue = (val) => { 
    setInsured(val)
    handleResetEligibilityDetails()
    handleCheckEligibility(val);
   }


  const overrides = {
    selectInsured: {
      label: isEndorsement ? messages.NameInsuredFieldPolChange.defaultMessage : messages.NameInsuredField.defaultMessage,
      readOnly: !isEndorsement,
      onValueChange: selectInsuredValue,
      availableValues: selectInsuredAvaialbleValues,
      value: isEndorsement ? insured : getContactDetails(insured).displayName,
      disabled: isEndorsement && (isCurrentPayPlanPayroll() ||  isBasedOnPayroll) 
    },
    mailingAddress: {
      value: getContactDetails(insured).primaryAddress.displayName,
    },
    zipCode: {
      onValueChange: (value) => {
        setZipCode(value);
        setSsnOrAltId("");
      },
      value: zipCode,
      disabled: isEndorsement && (!isEditableVisibleForPolicyChange(model, isEndorsement) && employeeInfo?.name) 
    },

    lastName: {
      onValueChange: (value) => {
        setLastName(value);
        setSsnOrAltId("");
      },
      value: lastName,
      visible: !isQnb,
      disabled: isEndorsement && (!isEditableVisibleForPolicyChange(model, isEndorsement) && employeeInfo?.name) 
    },

    altId: {
      onValueChange: (value) => {
        setSsnOrAltId(value);
        setLastName("");
        setZipCode("");
      },
      value: ssnOrAltId,
      placeholder: alertnateIdLabel,
      label: `or ${alertnateIdLabel}`,
      visible: !isQnb,
      disabled: isEndorsement && (!isEditableVisibleForPolicyChange(model, isEndorsement) && employeeInfo?.name) 

    },
    eligibilityFileSearchTable: {
      data: eligibilityDetails,
      disabled: isEndorsement && (!isEditableVisibleForPolicyChange(model, isEndorsement) && employeeInfo?.name) 
    },
    eligibilityFilename: {
      value: employeeInfo?.name,
    },
    eligibilityFileAddress: {
      value: employeeInfo?.address,
    },
    eligibilitySearchDetails: {
      visible: _.isEmpty(employeeInfo?.name),
    },
    selectedEligibilityfileContainer: {
      visible: !_.isEmpty(employeeInfo?.name),
    },
    verifyEligibilityFile: {
      value: isChecked,
      required: true,
      onValueChange: handleCheckbox,
      visible: !_.isEmpty(employeeInfo?.name) && isVerficationBoxVisible,
      disabled: isEndorsement && (!isEditableVisibleForPolicyChange(model, isEndorsement) && employeeInfo?.name) 
    },
    employeenumberHeader: {
      header: alertnateIdLabel,
    },
    checkEligibility: {
      visible: false,
      content: translator(messages.checkEligibilityBtnLabel),
      onClick: handleCheckEligibility,
    },
    removeEmployeeEligibility: {
      visible: !_.isEmpty(eligibilityDetails) || !_.isEmpty(employeeInfo?.name),
      content: translator(messages.removeEligibility),
      onClick: handleResetEligibilityDetails,
      disabled: (isEndorsement && (isBasedOnPayroll || isCurrentPayPlanPayroll()))  
  }
}

  const resolvers = {
    resolveCallbackMap: {
      handleEligibilitySearch,
      getCell,
      handleResetEligibilityDetails,
      handleCheckEligibility,
    },
  };

  return (
    <ViewModelForm
      uiProps={metadata.componentContent}
      model={model}
      classNameMap={styles}
      callbackMap={resolvers.resolveCallbackMap}
      overrideProps={overrides}
    />
  );
}

MLEmployeeEligibility.propTypes = {
  model: PropTypes.shape({}).isRequired,
  eligibilityInfos: PropTypes.array.isRequired,
  isEndorsement: PropTypes.bool,
  quoteID: PropTypes.string,
  setDisableNextButton: PropTypes.func,
  pni: PropTypes.shape({}),
  sni: PropTypes.shape({}),
  isBasedOnPayroll: PropTypes.bool,
  isCurrentPayPlanPayroll: PropTypes.func
};

MLEmployeeEligibility.defaultProps = {
  isEndorsement: false,
  setDisableNextButton : () => false,
  isBasedOnPayroll: false,
  isCurrentPayPlanPayroll: _.noop,
};

export default MLEmployeeEligibility;
